import React, { useEffect, useState } from 'react';
import { BadgeCheckIcon, CheckIcon, Clock3Icon, CreditCardIcon, LockKeyholeIcon, ShieldCheckIcon, UsersRoundIcon } from 'lucide-react';
import { BookMockup } from './BookMockup';
import { CART_URL } from './constants';
import { trackAddToCart } from './MetaPixel';
import { scheduleNonCritical } from './scheduling';
import { useCurrency } from './currency/CurrencyContext';
import { Price } from './currency/Price';
const bonuses = [['01', 'El secreto para congelar alimentos', 'Haz que tus comidas conserven su sabor y textura.'], ['02', '25 snacks saludables', 'Ideas prácticas para tener opciones listas entre comidas.'], ['03', 'Cómo ahorrar hasta un 45% en el supermercado', 'Compra con intención y aprovecha mejor cada alimento.'], ['04', 'El arte de recalentar', 'Recupera el punto perfecto de tus preparaciones.'], ['05', 'Cómo guardar tus alimentos para que duren más', 'Una guía sencilla para evitar desperdicios.'], ['Extra', 'Planner semanal + lista de compras', 'Tu mapa para organizar comidas y compras de la semana.']];
const OFFER_DURATION_SECONDS = 10 * 60;
export function BonusOffer() {
  const {
    buildCartUrl
  } = useCurrency();
  const [secondsRemaining, setSecondsRemaining] = useState(OFFER_DURATION_SECONDS);
  useEffect(() => {
    let isCancelled = false;
    let intervalId: number | undefined;
    scheduleNonCritical(() => {
      if (isCancelled) {
        return;
      }
      intervalId = window.setInterval(() => {
        setSecondsRemaining(currentSeconds => currentSeconds > 0 ? currentSeconds - 1 : 0);
      }, 1000);
    });
    return () => {
      isCancelled = true;
      if (intervalId) {
        window.clearInterval(intervalId);
      }
    };
  }, []);
  const minutes = Math.floor(secondsRemaining / 60);
  const seconds = secondsRemaining % 60;
  const formattedTimer = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  return <section id="oferta" className="bg-[#143827] px-5 py-16 text-[#fffaf0] sm:px-8 sm:py-24" data-id="element-28" data-mp="26doxfjy9qea5">
      <div className="mx-auto grid max-w-7xl gap-12 lg:grid-cols-[1.05fr_0.95fr] lg:gap-20" data-id="element-29" data-mp="2bd1ji2hbfhbo">
        <div data-id="element-30" data-mp="2gbl5u3ztmv4k">
          <p className="text-sm font-bold uppercase tracking-[0.16em] text-[#c5dfbb]" data-id="element-31" data-mp="2gc4ndjlk7hi2">
            Además, totalmente gratis
          </p>
          <h2 className="font-display mt-4 text-4xl font-black leading-[0.98] tracking-[-0.045em] sm:text-5xl" data-id="element-32" data-mp="2kd6ch7lrid6b">
            🎁 Los extras que hacen que tu plan sea sostenible.
          </h2>
          <div className="mt-8 space-y-3" data-id="element-33" data-mp="2u3rl7nv5gy2y">
            {bonuses.map(([number, title, description]) => <article key={title} className="flex gap-4 rounded-xl border border-[#406c54] bg-[#1c4933] p-4" data-id="element-34" data-mp="2z1kp2a8zdg02">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-[#a92d3d] text-xs font-black uppercase text-white" data-id="element-35" data-mp="38293v7677ke0">
                  {number}
                </span>
                <div data-id="element-36" data-mp="sdu3sd50nap3">
                  <h3 className="font-bold text-[#fffdf7]" data-id="element-37" data-mp="sdant1yxewdp">{title}</h3>
                  <p className="mt-1 text-sm leading-relaxed text-[#cfe0d2]" data-id="element-38" data-mp="neh9j7btf1ch">
                    {description}
                  </p>
                </div>
                <span className="ml-auto hidden h-fit whitespace-nowrap rounded-full bg-[#c5dfbb] px-2.5 py-1 text-xs font-extrabold text-[#143827] sm:block" data-id="element-39" data-mp="ii0kmawskiyc">
                  GRATIS
                </span>
              </article>)}
          </div>
        </div>
        <aside className="self-center rounded-[2rem] bg-[#fffaf0] p-6 text-[#143827] shadow-2xl sm:p-9" aria-label="Oferta Meal Prep Club" data-id="element-40" data-mp="16cjzppg3n4bv">
          <div className="flex items-start justify-between gap-4" data-id="element-41" data-mp="1yunvv4712upf">
            <div data-id="element-42" data-mp="1yvz53jj8sunx">
              <p className="text-sm font-bold uppercase tracking-[0.13em] text-[#a92d3d]" data-id="element-43" data-mp="1u3pfk4m1hwm6">
                Oferta de hoy
              </p>
              <h2 className="font-display mt-2 text-3xl font-black tracking-[-0.04em]" data-id="element-44" data-mp="1ekmuo8ap3i9m">
                Meal Prep Club completo
              </h2>
            </div>
            <BadgeCheckIcon aria-hidden="true" className="h-8 w-8 shrink-0 text-[#a92d3d]" data-id="element-45" data-mp="14nrulkyrx9t8" />
          </div>
          <div className="my-7 rounded-2xl bg-[#e8f0df] px-4 py-6 sm:px-6" data-id="element-46" data-mp="19mlatl5g3ex3">
            <BookMockup compact data-id="element-47" data-mp="1xcyw8stiyfip" />
            <div className="mt-6 text-center" data-id="element-48" data-mp="1xe0fhkkp28bi">
              <p className="font-display text-4xl font-black leading-[0.9] tracking-[-0.055em] text-[#a92d3d] sm:text-5xl" data-id="element-49" data-mp="22ba26sgp85vn">
                +1000 recetas
              </p>
              <p className="mt-1 text-sm font-extrabold uppercase tracking-[0.14em] text-[#143827]" data-id="element-50" data-mp="1sl7biyx1v40h">
                Incluidas
              </p>
              <p className="mt-4 inline-flex items-center justify-center rounded-full bg-[#143827] px-4 py-2 text-sm font-black uppercase tracking-[0.08em] text-[#fffaf0]" data-id="element-51" data-mp="2ga00gbf98bll">
                + 5 bonos gratis
              </p>
            </div>
          </div>
          <div className="border-y border-[#eadfc9] py-5" data-id="element-52" data-mp="4ng3mrfkcpd3">
            <div className="flex items-end justify-between" data-id="element-53" data-mp="4n68kpfnvs0j">
              <div data-id="element-54" data-mp="if2wsie7lhrn">
                <p className="text-sm font-semibold text-[#6a7a6d]" data-id="element-55" data-mp="idji2w87berz">
                  Valor total
                </p>
                <p className="text-xl font-bold text-[#8b7863] line-through" data-id="element-56" data-mp="ee164pycye1a">
                  <Price amount={25.98} data-id="element-57" data-mp="3mtueghijcj79" />
                </p>
              </div>
              <div className="text-right" data-id="element-58" data-mp="3huq6tvb9etj1">
                <p className="text-sm font-semibold text-[#397352]" data-id="element-59" data-mp="3hw189oh8fp6z">
                  Hoy accedes por
                </p>
                <p className="font-display text-5xl font-black tracking-[-0.06em] text-[#a92d3d]" data-id="element-60" data-mp="3qumohcz8es4l">
                  <Price amount={12.99} data-id="element-61" data-mp="1b3i9gy9vbnzt" />
                </p>
              </div>
            </div>
          </div>

          <section className="mt-6 overflow-hidden rounded-2xl border border-[#d7838d] bg-[#fff4f4]" aria-labelledby="urgency-title" data-id="element-62" data-mp="164x8uxqpf2au">
            <div className="bg-[#a92d3d] px-4 py-3 text-center text-white sm:px-6" data-id="element-63" data-mp="3tc4fu90lo8i">
              <h3 id="urgency-title" className="text-base font-black tracking-wide" data-id="element-64" data-mp="8o9dv2a7hzlx">
                🔥 ¡OFERTA SOLO POR HOY!
              </h3>
            </div>
            <div className="p-4 sm:p-5" data-id="element-65" data-mp="hoo84r55ep1k">
              <div className="flex flex-col gap-2 text-center sm:flex-row sm:items-center sm:justify-between sm:text-left" data-id="element-66" data-mp="3h6oyt7w4tagz">
                <p className="font-extrabold text-[#9b2637]" data-id="element-67" data-mp="3l8ak9hmqex2s">
                  ¡El precio está por subir!
                </p>
                <p className="inline-flex items-center justify-center gap-1.5 text-xs font-bold text-[#6e3640]" aria-live="polite" data-id="element-68" data-mp="3q4hgujt8mw82">
                  <UsersRoundIcon aria-hidden="true" className="h-4 w-4 text-[#a92d3d]" data-id="element-69" data-mp="2xhmwro0c1yv4" />
                  31 personas están viendo esta oferta ahora mismo
                </p>
              </div>
              <p className="mt-4 text-center text-sm leading-relaxed text-[#593c3f]" data-id="element-70" data-mp="2pxvwldnxoe5j">
                Tu lugar está reservado durante 10 minutos. Si no completas tu
                compra dentro de ese tiempo, la oferta podría finalizar y el
                descuento dejará de estar disponible.
              </p>
              <div className="mt-4 rounded-xl border border-[#e7b7bd] bg-white px-4 py-3 text-center" data-id="element-71" data-mp="2bzo2rem71syl">
                <p className="flex items-center justify-center gap-1.5 text-xs font-bold uppercase tracking-[0.12em] text-[#7d3240]" data-id="element-72" data-mp="276uwunezoekx">
                  <Clock3Icon aria-hidden="true" className="h-4 w-4" data-id="element-73" data-mp="226qf6u2chdt4" /> Tiempo
                  restante
                </p>
                <p className="mt-1 font-mono text-4xl font-black tracking-[0.12em] text-[#a92d3d]" role="timer" aria-live="polite" aria-label={`Tiempo restante: ${formattedTimer}`} data-id="element-74" data-mp="1t84yl4gfo8uz">
                  {formattedTimer}
                </p>
              </div>
              <a href={buildCartUrl(CART_URL)} onClick={trackAddToCart} className="mt-4 flex w-full items-center justify-center rounded-xl bg-[#a92d3d] px-5 py-3.5 text-sm font-black tracking-wide text-white shadow-[0_5px_0_#6d1725] transition-[background-color,transform] duration-150 hover:-translate-y-0.5 hover:bg-[#8d2130] active:scale-[0.98] focus:outline-none focus:ring-4 focus:ring-[#f0b8c0]" data-id="element-75" data-mp="3h3hymulfg0n2">
                ¡AHORRA EL 50% AHORA!
              </a>
            </div>
          </section>

          <ul className="my-6 space-y-2 text-sm font-semibold text-[#46604d]" data-id="element-76" data-mp="2ofvunl8aetzo">
            {['Pago único', 'Acceso inmediato', '5 bonos exclusivos gratis', 'Planner semanal incluido'].map(item => <li key={item} className="flex gap-2" data-id="element-77" data-mp="2fhjt4o5vubsg">
                <CheckIcon aria-hidden="true" className="h-4 w-4 text-[#30714a]" data-id="element-78" data-mp="1vuqgn69xlm0l" />
                {item}
              </li>)}
          </ul>
          <a href={buildCartUrl(CART_URL)} onClick={trackAddToCart} className="flex w-full items-center justify-center gap-2 rounded-xl bg-[#37A637] px-5 py-4 font-extrabold text-white shadow-[0_6px_0_#1f6c1f] transition-[background-color,transform] duration-150 hover:-translate-y-0.5 hover:bg-[#2b872b] active:scale-[0.98] focus:outline-none focus:ring-4 focus:ring-[#bfe4bf]" data-id="element-79" data-mp="24verxt7xx89s">
            Acceder ahora por <Price amount={12.99} data-id="element-80" data-mp="2ok5pbpe4j2tc" />
          </a>
          <div className="mt-6 flex flex-wrap items-center justify-center gap-x-3 gap-y-2 text-xs font-semibold text-[#5d6e61]" data-id="element-81" data-mp="2jkb1jupnatci">
            <span className="flex items-center gap-1" data-id="element-82" data-mp="2xjangulrwu4z">
              <LockKeyholeIcon aria-hidden="true" className="h-3.5 w-3.5 text-[#397352]" data-id="element-83" data-mp="2skpo0xeciehl" />
              Pago seguro
            </span>
            <span className="flex items-center gap-1" data-id="element-84" data-mp="2sopym6oyh80r">
              <ShieldCheckIcon aria-hidden="true" className="h-3.5 w-3.5 text-[#397352]" data-id="element-85" data-mp="2sn54ujagtt3y" />
              Acceso protegido
            </span>
            <span className="flex items-center gap-1" data-id="element-86" data-mp="2irleeceo7mml">
              <CreditCardIcon aria-hidden="true" className="h-3.5 w-3.5 text-[#397352]" data-id="element-87" data-mp="3gdr019zdfiwj" />
              Visa · Mastercard
            </span>
          </div>
          <p className="mt-5 text-center text-xs leading-relaxed text-[#6a7a6d]" data-id="element-88" data-mp="36fl1n2crwuwf">
            Garantía de satisfacción de 7 días, conforme a las condiciones de la
            política de reembolso.
          </p>
        </aside>
      </div>
    </section>;
}